module.exports = __webpack_public_path__ + "img/Recruit_Video_Banner_Poster.5236be29.png";